import { CommonEnums } from 'src/app/shared/common.enums';

export class DCmd_Inst {
    dxFlow_Id: number;
    dCmd_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    nativeDbTyp_Id: number;
    dCmd: string;
    valid_Cd: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    conn_Valid_Cd: string;
    disableFlg: string;
    fileNm: string;
    location: string;
    sqlFileFlg: string;
    outPutFile: string;
    continueExeOnFail: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    sqlType:string;
    constructor() {
        this.setDefault();
    }
    setDefault(): void {
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.dCmd_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.dCmd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date;
        this.conn_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_EMPTY;
        this.fileNm = CommonEnums.defaults.STRING_EMPTY;
        this.location = CommonEnums.defaults.STRING_EMPTY;
        this.sqlFileFlg = CommonEnums.defaults.STRING_EMPTY;
        this.outPutFile = CommonEnums.defaults.STRING_EMPTY;
        this.continueExeOnFail = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
        this.sqlType= CommonEnums.defaults.STRING_EMPTY;
    }

    getPrimaryKey(): string {
        return this.dxFlow_Id + '.' + this.dCmd_Inst_Id;
    }

    copy(): DCmd_Inst {
        let dCmd_InstTmp: DCmd_Inst = new DCmd_Inst();

        dCmd_InstTmp.dxFlow_Id = this.dxFlow_Id;
        dCmd_InstTmp.dCmd_Inst_Id = this.dCmd_Inst_Id;
        dCmd_InstTmp.nm = this.nm;
        dCmd_InstTmp.description = this.description;
        dCmd_InstTmp.ver = this.ver;
        dCmd_InstTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        dCmd_InstTmp.dCmd = this.dCmd;
        dCmd_InstTmp.valid_Cd = this.valid_Cd;
        dCmd_InstTmp.updateBy = this.updateBy;
        dCmd_InstTmp.lastUpdateBy = this.lastUpdateBy;
        dCmd_InstTmp.updateDt = this.updateDt;
        dCmd_InstTmp.conn_Valid_Cd = this.conn_Valid_Cd;
        dCmd_InstTmp.disableFlg = this.disableFlg;
        dCmd_InstTmp.fileNm = this.fileNm;
        dCmd_InstTmp.location = this.location;
        dCmd_InstTmp.sqlFileFlg = this.sqlFileFlg;
        dCmd_InstTmp.outPutFile = this.outPutFile;
        dCmd_InstTmp.continueExeOnFail = this.continueExeOnFail;
        dCmd_InstTmp.retryEnabled = this.retryEnabled;
        dCmd_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        dCmd_InstTmp.retryWaitTime = this.retryWaitTime;
        dCmd_InstTmp.sqlType=this.sqlType;
        return dCmd_InstTmp;
    }

    copyFrom(dCmd_InstTmp: DCmd_Inst): void {
        this.dxFlow_Id = dCmd_InstTmp.dxFlow_Id;
        this.dCmd_Inst_Id = dCmd_InstTmp.dCmd_Inst_Id;
        this.nm = dCmd_InstTmp.nm;
        this.description = dCmd_InstTmp.description;
        this.ver = dCmd_InstTmp.ver;
        this.nativeDbTyp_Id = dCmd_InstTmp.nativeDbTyp_Id;
        this.dCmd = dCmd_InstTmp.dCmd;
        this.valid_Cd = dCmd_InstTmp.valid_Cd;
        this.updateBy = dCmd_InstTmp.updateBy;
        this.updateDt = dCmd_InstTmp.updateDt;
        this.lastUpdateBy =dCmd_InstTmp.lastUpdateBy;
        this.conn_Valid_Cd = dCmd_InstTmp.conn_Valid_Cd;
        this.disableFlg = dCmd_InstTmp.disableFlg;
        this.fileNm = dCmd_InstTmp.fileNm;
        this.location = dCmd_InstTmp.location;
        this.sqlFileFlg = dCmd_InstTmp.sqlFileFlg;
        this.outPutFile = dCmd_InstTmp.outPutFile;
        this.continueExeOnFail = dCmd_InstTmp.continueExeOnFail;
        this.retryEnabled = dCmd_InstTmp.retryEnabled;
        this.numOfRetryAttempts = dCmd_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = dCmd_InstTmp.retryWaitTime;
        this.sqlType =dCmd_InstTmp.sqlType;
    }

    compare(dCmd_InstTmp: DCmd_Inst): string {
        let dCmd_InstString: string = this.toString(false);
        let dCmd_InstTmpString: string = dCmd_InstTmp.toString(false);

        if (dCmd_InstString != dCmd_InstTmpString) {
            return dCmd_InstString + ', ' + dCmd_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DCmd_Inst [dxFlow_Id =" + this.dxFlow_Id + ", dCmd_Inst_Id =" + this.dCmd_Inst_Id +
            ", nm =" + this.nm + ", description =" + this.description + ",ver =" + this.ver+
            ", nativeDbTyp_Id =" + this.nativeDbTyp_Id + ", dCmd =" + this.dCmd + ", valid_Cd =" + this.valid_Cd +
            ", updateBy =" + this.updateBy +  ", updateDt =" + this.updateDt+
            ", conn_Valid_Cd =" + this.conn_Valid_Cd + ", disableFlg =" + this.disableFlg + ", fileNm =" + this.fileNm +
            ", location =" + this.location + ", sqlFileFlg =" + this.sqlFileFlg +
            ", outPutFile =" + this.outPutFile + ", continueExeOnFail =" + this.continueExeOnFail+
            ",retryEnabled =" + this.retryEnabled +",numOfRetryAttempts =" + this.numOfRetryAttempts +
            ",retryWaitTime =" + this.retryWaitTime + ",sqlType =" + this.sqlType;

        if (isNotCompare) {
            str +=  ", lastUpdateBy =" + this.lastUpdateBy; 
               
        }

        str += ']';

        return str;
    }
}